import { Grid } from '@mui/material'
import React from 'react'
import ImageComponent from './ImageComponent'
import { TextBold, TextRegular, TextSemiBold } from './TextStyling'
import appassets from '../utils/appassets'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@mui/styles'

export default function CompanyDetailsUI ({ item }) {
  const navigate = useNavigate()
  const theme = useTheme()
  return (
    <Grid container>
      <Grid item style={{ display: 'flex', flexGrow: 1 }}>
        <Grid
          item
          style={{
            display: 'flex',
            justifyContent: 'center',
            border: `1px solid ${theme.palette.border.main}`,
            width: '57px',
            height: '56px',
            borderRadius: '16px',
            overflow: 'hidden',
            padding: '4px',
            objectFit: 'contain',
            alignItems: 'center'
          }}
        >
          <ImageComponent
            alt='company logo'
            src={item.profilePicture}
            style={{ width: '100%' }}
          />
        </Grid>
        <Grid item style={{ paddingLeft: '16px' }}>
          <Grid item xs={12}>
            <TextBold
              style={{
                fontSize: '18px'
              }}
            >
              {item.jobTitle}
            </TextBold>
          </Grid>

          <Grid
            item
            xs={12}
            style={{
              marginTop: '8px'
            }}
          >
            <TextSemiBold
              style={{
                cursor: 'pointer',
                lineHeight: '24px',
                color: theme.palette.primary.main
              }}
              onClick={() =>
                navigate('/recruiter/newcompany', {
                  state: item
                })
              }
            >
              {item.companyname} - {item.city},{item.countryName}
            </TextSemiBold>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid item>
          <Grid
            item
            style={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <img
              src={`${appassets.location}`}
              alt='location'
              style={{ marginRight: '8px' }}
            />
            <TextRegular
              style={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '16px',
                lineHeight: '24px',
                color: theme.palette.text.secondary,
                paddingRight: '16px'
              }}
            >
              {item.city}, {item.state}, {item.countryName}
            </TextRegular>
          </Grid>
        </Grid>
        <Grid item style={{ marginTop: '8px' }}>
          <Grid container direction={'row'}>
            <Grid
              item
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <img
                src={`${appassets.suitcase}`}
                alt='suitcase'
                style={{ marginRight: '8px' }}
              />
              <TextRegular
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: theme.palette.text.secondary,
                  paddingRight: '16px',
                  width: '6rem'
                }}
              >
                {item.jobTypeName}
              </TextRegular>
            </Grid>
            <Grid
              item
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <img
                src={`${appassets.time}`}
                alt='time'
                style={{ marginRight: '8px' }}
              />
              <TextRegular
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '16px',
                  lineHeight: '24px',
                  color: theme.palette.text.secondary,
                  paddingRight: '16px'
                }}
              >
                {moment(item?.createdAt).fromNow()}
              </TextRegular>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}
